import React, { useContext, useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { CallCard } from './CallCard';
import { CallCardProduct } from './CallCardProduct';
import { EventsStoreContext } from '../reducers/Events/EventsContext';
import moment from 'moment';
import { Howl } from 'howler';
import AppMessage from './AppMessage';

let beepInterval = null;

const beep = () => {
  const sound = new Howl({
    src: ['./call.mp3'],
  });
  sound.play();
};

const PerOrderManagement = () => {
  const [eventsState] = useContext(EventsStoreContext);
  const [beeping, setBeeping] = useState(false);
  const [calls, setCalls] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      if (beepInterval !== null) {
        clearInterval(beepInterval);
        beepInterval = null;
      }
    };
  }, []);

  useEffect(() => {
    const beepingActiveEvents = Object.keys(eventsState.calls).length;
    beepingActiveEvents > 0 ? setBeeping(true) : setBeeping(false);
  }, [eventsState]);

  useEffect(() => {
    if (!beeping) {
      beepInterval !== null && clearInterval(beepInterval);
      beepInterval = null;
    } else if (beepInterval === null) {
      beep();
      beepInterval = setInterval(beep, 5000);
    }
  }, [beeping]);

  useEffect(() => {
    if (!eventsState.initialized) return;

    const unresolveCalls = [];
    for (const pointId in eventsState.calls) {
      const foundCalls = eventsState.calls[pointId].sort((event1, event2) => {
        const comparison = moment(event1.createdAt).valueOf() - moment(event2.createdAt).valueOf();
        return comparison;
      });
      if (foundCalls.length > 0) {
        const [firstCall] = foundCalls;
        const lastCall = foundCalls.length === 1 ? firstCall : foundCalls[foundCalls.length - 1];
        const callInserted = {
          ...firstCall,
          details: lastCall.details,
        };
        unresolveCalls.push(callInserted);
      }
    }

    unresolveCalls.sort((event1, event2) => {
      const comparison = moment(event1.createdAt).valueOf() - moment(event2.createdAt).valueOf();
      return comparison;
    });

    setCalls(unresolveCalls);
  }, [eventsState]);

  if (calls === null) {
    return <AppMessage message="Getting calls ..." />;
  }

  if (calls?.length === 0) {
    return <AppMessage message="No calls yet!..." />;
  }

  const responsive = { xs: 12, sm: 6, md: 4, lg: 3 };

  return (
    <Grid container style={{ margin: '80px 0 100px 0', padding: '4px' }}>
      {calls.map((call) => {
        const { details } = call;
        const hasProductRequest =
          typeof details?.productId === 'string' && details?.productId.length > 0;
        if (hasProductRequest) {
          return (
            <Grid key={call.id} item container {...responsive}>
              <CallCardProduct event={call} />
            </Grid>
          );
        }

        return (
          <Grid key={call.id} item container {...responsive}>
            <CallCard event={call} />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default PerOrderManagement;
